import React, { useEffect, useState, useMemo } from 'react';
import JoinGroupContent from 'app/components/group/JoinGroupContent';
import {
  useSelectGroupList,
  useSelectFollowedGroupList,
} from 'entity/group/groupHooks';
import { openLoginModal } from 'app/dispatcher/modalDispatcher';
import { Button } from 'app/seedly-component-library';
import { useDispatch } from 'react-redux';
import { followGroupsRequest } from 'entity/group/groupRedux';
import { useIsSignedIn } from 'app/entity/user/userHooks';
import { LOGIN_MODAL, TYPES } from 'app/constants/login';
import { filterGroups } from 'app/entity/group/groupUtils';

const JoinGroupsContent = () => {
  const groupList = useSelectGroupList();
  const followedGroupList = useSelectFollowedGroupList();
  const isSignedIn = useIsSignedIn();

  const dispatch = useDispatch();

  const groups = useMemo(() => filterGroups(groupList), [groupList]);

  const [selectedGroupIds, setSelectedGroupIds] = useState<number[]>(() => {
    return groups.topThreeGroups.map(group => group.id);
  });

  useEffect(() => {
    if (followedGroupList.length > 0) {
      setSelectedGroupIds(followedGroupList.map(group => group.id));
    }
  }, [followedGroupList]);

  const handleSelectedGroupIds = ids => {
    setSelectedGroupIds(ids);
  };

  return (
    <div className="card">
      <div className="flex flex-col gap-6">
        <p className="text-base font-bold">Create your Community Homepage</p>
        <JoinGroupContent
          groups={groups}
          selectedGroupIds={selectedGroupIds}
          handleSelectedGroupIds={handleSelectedGroupIds}
        />
        <div className="border-none bg-white p-4 fixed bottom-0 left-0 right-0 md:relative md:p-0 z-10">
          <div className="flex flex-col items-center gap-4 w-full">
            <Button
              onClick={() => {
                if (isSignedIn) {
                  dispatch(followGroupsRequest(selectedGroupIds));
                } else {
                  sessionStorage.setItem(
                    'follow_groups_upon_sign_up',
                    JSON.stringify(selectedGroupIds),
                  );
                  dispatch(
                    openLoginModal({
                      ...LOGIN_MODAL[TYPES.FOLLOW_GROUPS],
                      group_selection: groupList
                        .filter(g => selectedGroupIds.includes(g.id))
                        .map(g => g.name)
                        .join(','),
                    }),
                  );
                }
                window.scrollTo(0, 0);
              }}
              size="lg"
              disabled={selectedGroupIds.length < 3}
              isBlock
            >
              {isSignedIn && followedGroupList.length > 0
                ? 'Load Home Feed'
                : 'Join 3 or more to continue'}
            </Button>
            {!isSignedIn && (
              <p className="text-neutral-500">
                Already have an account?&nbsp;
                <span
                  className="text-blue-500 hover:underline cursor-pointer"
                  onClick={() => dispatch(openLoginModal())}
                >
                  Login here
                </span>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinGroupsContent;
